import React from 'react';
import { Button, Space, Popconfirm } from 'antd';
import {
  PlusOutlined, EditOutlined, SaveOutlined, CloseCircleOutlined,
  DeleteOutlined,
  LeftOutlined, RightOutlined, VerticalRightOutlined, VerticalLeftOutlined,
} from '@ant-design/icons';
import type { FormMode } from '../hooks/usePWP253Mode';

interface Props {
  mode: FormMode;
  hasRecord: boolean;
  hasPrev: boolean;
  hasNext: boolean;
  loading: boolean;
  onAdd: () => void;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete: () => void;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
}

const ActionBar: React.FC<Props> = ({
  mode, hasRecord, hasPrev, hasNext, loading,
  onAdd, onEdit, onSave, onCancel, onDelete,
  onFirst, onPrev, onNext, onLast,
}) => {
  const isEditing = mode === 'add' || mode === 'edit';

  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      marginBottom: 16, flexWrap: 'wrap', gap: 8,
    }}>
      <Space wrap>
        {!isEditing && (
          <>
            <Button icon={<PlusOutlined />} onClick={onAdd}>新增</Button>
            <Button icon={<EditOutlined />} onClick={onEdit} disabled={!hasRecord}>修改</Button>
            <Popconfirm title="確定要刪除此筆?" onConfirm={onDelete} disabled={!hasRecord}>
              <Button icon={<DeleteOutlined />} danger disabled={!hasRecord}>刪除</Button>
            </Popconfirm>
          </>
        )}
        {isEditing && (
          <>
            <Button type="primary" icon={<SaveOutlined />} onClick={onSave} loading={loading}>
              存檔
            </Button>
            <Button icon={<CloseCircleOutlined />} onClick={onCancel}>還原</Button>
          </>
        )}
      </Space>

      <Space wrap>
        <Button icon={<VerticalRightOutlined />} onClick={onFirst} disabled={isEditing || !hasPrev} title="最前" />
        <Button icon={<LeftOutlined />} onClick={onPrev} disabled={isEditing || !hasPrev} title="上一筆" />
        <Button icon={<RightOutlined />} onClick={onNext} disabled={isEditing || !hasNext} title="下一筆" />
        <Button icon={<VerticalLeftOutlined />} onClick={onLast} disabled={isEditing || !hasNext} title="最後" />
      </Space>
    </div>
  );
};

export default ActionBar;
